import React from "react";
import Card from "../../../../componentes/contenedores/Card";
import Page from "../../../../componentes/plantilla/Page";
import { useContextEmpleado } from "../../../../contexto/empleado/EmpleadoContext";
import TablaBuscarProveedores from "./TablaBuscarProveedores";

const HomeBuscarProveedores = () => {
    const { listaProveedores } = useContextEmpleado();
    const datos = {
        titulo: {
            titulo: "Busqueda proveedor",
            url: "/app/admin/proveedores/buscar",
            tituloUrl: "Menu Proveedores",
            nombreUrl: "Inicio ",
        },
    };

    return (
        <Page datos={datos}>
            <Card titulo="Lista de Proveedores">
                <TablaBuscarProveedores datos={listaProveedores}></TablaBuscarProveedores>
            </Card>
        </Page>
    );
}

export default HomeBuscarProveedores;